import axios from "axios"

const API_CONFIG = {
  biel: {
    development: {
      protocol: "http",
      host: "localhost",
      port: process.env.REACT_APP_API_HOST_BIEL || "4001"
    },
    production: {
      protocol: "https",
      host: process.env.REACT_APP_API_URL_BIEL,
      port: "443"
    }
  },
  basel: {
    development: {
      protocol: "http",
      host: "localhost",
      port: process.env.REACT_APP_API_HOST_BASEL || "4000"
    },
    production: {
      protocol: "https",
      host: process.env.REACT_APP_API_URL_BASEL,
      port: "443"
    }
  }
}

let env = process.env.NODE_ENV
if (env === "test") env = "development"

const getHost = (region = "basel") => API_CONFIG[region][env].host
const getPort = (region = "basel") => API_CONFIG[region][env].port
const getProtocol = (region = "basel") => API_CONFIG[region][env].protocol

const buildUrl = (protocol, host, port) => `${protocol}://${host}:${port}`

const DEFAULT_CONFIG = {
  headers: {
    common: {
      uid: "",
      client: "",
      "access-token": "",
      locale: "de"
    }
  },
  baseURL: buildUrl(getProtocol(), getHost(), getPort())
}

const ShelfApi = axios.create(DEFAULT_CONFIG)

// Load configuration from localStorage
ShelfApi.loadConfiguration = () => {
  const region = localStorage.getItem("region") || "basel"
  const lng = localStorage.getItem("i18nextLng") || "de"

  const configuration = {
    headers: {
      common: {
        uid: localStorage.getItem("uid"),
        client: localStorage.getItem("client"),
        "access-token": localStorage.getItem("accessToken"),
        "Accept-Language": `${lng}-ch`
      }
    },
    baseURL: buildUrl(getProtocol(region), getHost(region), getPort(region))
  }

  ShelfApi.defaults = Object.assign(ShelfApi.defaults, configuration)
}

ShelfApi.changeLanguage = lng => {
  ShelfApi.defaults.headers.common["Accept-Language"] = `${lng}-ch`
}

// Remove configuration by resetting to default
ShelfApi.removeConfiguration = () => {
  ShelfApi.defaults = DEFAULT_CONFIG
}

// Helper method that includes "API V2" header
ShelfApi.postV2 = (url, params = {}) => {
  const headers = {
    common: {
      Accept: `application/vnd.shelf.v2, ${ShelfApi.defaults.headers.common.Accept}`
    }
  }
  return ShelfApi.post(url, params, {headers})
}

// Save rotated auth headers so the 1-year session keeps sliding while in use.
ShelfApi.interceptors.response.use(response => {
  const token = response.headers["access-token"]
  const client = response.headers["client"]
  const expiry = response.headers["expiry"]
  const uid = response.headers["uid"]

  if (
    token &&
    String(token).trim() &&
    client &&
    expiry &&
    String(expiry).trim() &&
    uid
  ) {
    localStorage.setItem("accessToken", token)
    localStorage.setItem("client", client)
    localStorage.setItem("expiry", expiry)
    localStorage.setItem("uid", uid)
    ShelfApi.defaults.headers.common["access-token"] = token
    ShelfApi.defaults.headers.common.client = client
    ShelfApi.defaults.headers.common.uid = uid
  }

  return response
})

export default ShelfApi



// WEBPACK FOOTER //
// ./src/utils/ShelfApi.js